export const POLL_INTERVAL_MS = 15_000;

const STALE_THRESHOLD_MS = 90_000;

export function isOnline(lastSeenAt: string | null): boolean {
  if (!lastSeenAt) {
    return false;
  }

  return Date.now() - new Date(lastSeenAt).getTime() < STALE_THRESHOLD_MS;
}
